import React from 'react';

const EulaContent = (
  <div>
    <p>
      IMPORTANT: BEFORE ACCESSING OR USING ANY PART OF THE PROPEL TMS (THE
      “SERVICE”), YOU SHOULD READ CAREFULLY THE FOLLOWING TERMS AND CONDITIONS
      OF SERVICE (THE “TERMS AND CONDITIONS”). THIS IS A LEGAL AGREEMENT BETWEEN
      YOU AND PROPEL SOFTWARE SOLUTIONS, LLC (“PROPEL”). FOR PURPOSES OF THESE
      TERMS AND CONDITIONS, “PROPEL” SHALL INCLUDE ANY PARENT, SUBSIDIARY, OR
      AFFILIATED COMPANY. THESE TERMS AND CONDITIONS GOVERN YOUR ACCESS TO AND
      USE OF THE SERVICES, PRODUCTS, APPLICATIONS, SOFTWARE, PROGRAMS, TOOLS,
      MATERIALS, CONTENT, WEBSITES OR PAGES, MOBILE APPLICATIONS, INSTALLED
      APPLICATIONS, ELECTRONIC DATA INTERCHANGE, E-MAIL, AND SERVICE OFFERINGS
      OR INFORMATION AVAILABLE THROUGH THE WEBSITE OR USED IN ANY MANNER RELATED
      THERETO (COLLECTIVELY REFERRED TO HEREIN AS THE “SERVICE” AND/OR THE
      “SERVICES”). PROPEL IS WILLING TO ALLOW YOU ACCESS TO AND USE OF THE
      SERVICE ON THE CONDITION THAT YOU ACCEPT AND AGREE TO ALL OF THE TERMS AND
      CONDITIONS. IF YOU DO NOT AGREE WITH THE TERMS AND CONDITIONS, YOU ARE NOT
      GRANTED PERMISSION TO ACCESS OR OTHERWISE USE THE SERVICE. BY ACCESSING,
      VIEWING, OR USING THE WEBSITE AND SERVICES, YOU INDICATE THAT YOU HAVE
      READ AND UNDERSTAND THE TERMS AND CONDITIONS HEREIN AND, AS THEY MAY
      CHANGE FROM TIME TO TIME, THAT YOU AGREE TO THEM AND INTEND TO BE LEGALLY
      BOUND BY THEM. “YOU” OR “YOUR” REFERS TO THE INDIVIDUAL USING THE SERVICE
      AND IF YOU USE THE SERVICE ON BEHALF OF A CORPORATION, LLC, PARTNERSHIP,
      OR OTHER BUSINESS ENTITY, THEN “YOU” SHALL INCLUDE THAT BUSINESS ENTITY
      AND ANY INDIVIDUALS ASSOCIATED THEREWITH USING THE SERVICE. IF YOU ARE
      USING THE SERVICE ON BEHALF OF A BUSINESS OR OTHER LEGAL ENTITY, YOU ARE
      NEVERTHELESS INDIVIDUALLY BOUND BY THESE TERMS AND CONDITIONS EVEN IF YOUR
      COMPANY HAS A SEPARATE AGREEMENT WITH PROPEL.
    </p>
    <p>
      <b>1. USER INFORMATION REQUIRED:</b> YOU must provide YOUR first name,
      last name, company/business name, a valid email address and any other
      information requested in order to complete the signup/login process. YOU
      agree that this information provided by YOU will be accurate and current
      and YOU further agree to maintain and promptly update this information as
      necessary.{' '}
    </p>
    <p>
      <b>2. ACCOUNT SECURITY:</b> YOU agree that YOU are responsible for
      maintaining and protecting the security of YOUR SERVICES account and
      password. YOU further agree that PROPEL is not liable for any loss or
      damage resulting from YOUR failure to comply with this security
      obligation. YOU will refrain from charging anyone for access to any
      portion of the SERVICE, or any information therein. YOU will not allow
      non-registered users access to the SERVICE nor share any information from
      the SERVICE with any non-authorized users. Further, YOU agree YOU are
      fully responsible for anything that happens through YOUR account.
    </p>
    <p>
      <b>3. INFORMATION PROVIDED BY YOU TO PROPEL:</b> By providing information
      through the SERVICE, YOU represent and warrant that YOU are entitled to
      submit the information and that the information is true, accurate,
      complete, current, not confidential, and not in violation of any
      contractual restrictions or other third-party rights. It is YOUR
      responsibility to ensure the accuracy of all information provided and to
      keep YOUR profile information accurate and updated.
    </p>
    <p>
      <b>4. USER ELIGIBILITY AND REQUIREMENTS:</b> To be eligible to use the
      SERVICE, YOU must meet the following criteria and represent and warrant
      that YOU: (1) are 18 years of age or older; (2) are not currently
      restricted from the SERVICES, or not otherwise prohibited from having an
      account, (3) have full power and authority to agree to these Terms and
      Conditions and doing so will not violate any other agreement to which YOU
      are a party; (4) will not violate any rights of PROPEL, including these
      TERMS AND CONDITIONS and/or any intellectual property rights such as
      copyright, patent, licensing, or trademark rights; (5) agree to provide at
      YOUR cost all equipment, software, and internet access necessary to use
      the SERVICES; and (6) agree not to reproduce, copy, sell, resell, or
      exploit any portion of the SERVICE (including, but not limited to, the
      HTML/CSS or visual design elements of the WEBSITE), or use the SERVICE or
      access the SERVICE without the express written permission of PROPEL.
      Violation of this paragraph may result in civil and/or criminal penalties
      and fines as well as liability for attorney fees.{' '}
    </p>
    <p>
      <b>5. MISUSE OF THE SERVICES:</b> YOU agree to use the SERVICE only for
      the purpose for which it is intended. YOU agree not to modify, adapt,
      reverse engineer, create derivative works from, or hack the SERVICE or
      modify another WEBSITE so as to falsely imply that it is associated with
      the SERVICE, PROPEL, any PROPEL affiliates or any other PROPEL service.
      YOU agree not to use the SERVICE for any illegal or unauthorized purpose
      or activities. YOU agree not to upload, post, host or transmit unsolicited
      emails or text messages including “junk mail” and “spam” messages or
      upload, post, host, e-mail, or transmit any content that is unlawful,
      offensive, threatening, libelous, defamatory, pornographic, obscene or
      otherwise objectionable or violates any party’s intellectual property
      rights or these Terms and Conditions. YOU agree not to knowingly transmit
      any worm or virus or code of a destructive nature which interferes in any
      way with the SERVICE.
    </p>
    <p>
      <b>6. COOKIES:</b> PROPEL’s WEBSITE or ISP uses cookies to retrieve user
      details for each visit. Cookies are used in some areas of our WEBSITE to
      enable the functionality and ease of use for those people visiting. YOUR
      IP address may be used to help diagnose technical problems or to
      administer
    </p>
  </div>
);

export default EulaContent;
